import React, { useImperativeHandle, forwardRef, useState } from 'react'

//images
import closeIcon from '../../../assets/images/interactive-road-signals/icons/close-icon.png'

function Info(props, ref) {
    const [modal, setModal] = useState({
        overlay: false,
        popup: false,
        name: '',
        text: '',
    })

    useImperativeHandle(ref, () => ({
        open: (name, text) => handleOpen(name, text),
        hide: () => handleClose()
    }))

    const handleOpen = (name, text) => {
        setModal(modal => ({
            ...modal,
            overlay: true,
            name: name,
            text: text
        }))
        setTimeout(() => {
            setModal(modal => ({
                ...modal,
                popup: true,
            }))
        }, 100)
    }

    const handleClose = () => {
        setModal(modal => ({
            ...modal,
            popup: false,
        }))
        setTimeout(() => {
            setModal(modal => ({
                ...modal,
                overlay: false,
            }))
        }, 50)
    }

    return (
        <div id="overlay" className={modal.overlay ? 'visible' : ''}>
            <div className={`box info ${modal.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    onClick={handleClose}
                />
                <h3>
                    {modal.name}
                </h3>
                <p>
                    {modal.text}
                </p>
            </div>
        </div>
    )
}

export default forwardRef(Info)